<template>
  <v-container class="pa-0" style="max-width:100%;">
    <v-layout wrap>
      <ul class="timeline-updates-list" style="list-style:none">
        <li>
          <template v-if="param && param.name">
            <h4>
              <div style="font-weight:400; display:inline-block">
                {{param.name}}
              </div>
              <span v-if="fromValue && toValue"> was changed from </span>
              <span v-else-if="toValue"> was set to </span>
              <span v-else> was cleared of </span>

              <i v-if="fromValue" style="font-weight:400;">{{ fromValue }}</i>

              <span v-if="fromValue && toValue"> to </span>
              <i v-if="toValue" style="font-weight:400; color:green">{{ toValue }}</i>.
            </h4>
          </template>
          <template v-else-if="param">
            <h4>
              <div style="font-weight:400; display:inline-block">{{ activityLabel }}</div> was changed from
              <i style="font-weight:400;">{{ param.from }}</i> to
              <i style="font-weight:400; color:green">{{ param.to }}</i>.
            </h4>
          </template>
        </li>
      </ul>
    </v-layout>
  </v-container>
</template>

<script>
import { lookupByEventType } from "@/stores/timeline/eventTypes"
export default {
  name: "SingleChange",
  data: () => ({
    activityText: {
      "case.state.changed": "State"
    }
  }),
  props: ["param", "activity"],
  computed: {
    activityLabel() {
      return lookupByEventType(this.activityText, this.activity)
    },
    fromValue() {
      return this.displayValue(this.param.from, this.param.fromDocument)
    },
    toValue() {
      return this.displayValue(this.param.to, this.param.toDocument)
    }
  },
  methods: {
    displayValue(value, document) {
      if (value !== undefined && value !== null && value !== "") {
        return value
      }
      if (document && document.filename) {
        return document.filename
      }
      return ""
    }
  }
}
</script>

<style>
.timeline-updates-list li {
  position: relative;
  padding: 0 0 5px 0;
}
</style>
